import { useEffect, useRef, useState } from 'react';
import { borraListaUsuPuesto, obtieneUsuarioPuesto, obtieneUsuOperadores, registraAcceso } from '../../services/HorarioTurno/TurnoService';
import { obtenerProyectoAdm, obtenerPuestoAdm } from '../../services/Monitor/MonitorService';
import { InputText } from 'primereact/inputtext';

const useUtilAdmin = () => {
    const [usuarios, setUsuarios] = useState();
    const [lstUsuarios, setLstUsuarios] = useState([]);
    const [cargaUsu, setCargaUsu] = useState(false);

    const [cargaProyecto, setCargaProyecto] = useState(false);
    const [lstProyecto, setLstProyecto] = useState([]);
    const [proyecto, setProyecto] = useState(null);

    const [cargaPuesto, setCargaPuesto] = useState(false);
    const [multiPuesto, setMultiPuesto] = useState();
    const [lstPuesto, setLstPuesto] = useState([]);

    const [procesaReg, setProcesaReg] = useState(false);
    const [procesaBorra, setProcesaBorra] = useState(false);

    const [datosUsuPue, setDatosUsuPue] = useState([]);
    const [datosUPSelect, setDatosUPSelect] = useState(null);
    const [actualiza, setActualiza] = useState(false);
    const [cargaDatUsuPue, setCargaDatUsuPue] = useState(false);

    const toast = useRef(null);

    useEffect(() => {
        setCargaUsu(true);
        const cargaUsuario = async () => {
            const data = await obtieneUsuOperadores();
            setLstUsuarios(data);
        };
        cargaUsuario();
        setCargaUsu(false);
    }, []);

    useEffect(() => {
        const cargarProyecto = async () => {
            try {
                const datos = await obtenerProyectoAdm();
                //console.log ('ww01', datos)
                setLstProyecto(datos);
                setCargaProyecto(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        cargarProyecto();
    }, []);

    useEffect(() => {
        const cargarPuesto = async () => {
            if (proyecto) {
                setCargaPuesto(true);
                try {
                    const datos = await obtenerPuestoAdm(proyecto.id);
                    //console.log('KK00:', datos)
                    setLstPuesto(datos);
                } catch (error) {
                    console.error(error.message);
                }
                setCargaPuesto(false);
            }
        };
        cargarPuesto();
    }, [proyecto]);

    useEffect(() => {
        const todosUsuarioPuesto = async () => {
            setCargaDatUsuPue(true);
            try {
                const data = await obtieneUsuarioPuesto();
                //console.log('KZKZ00:', data);
                setDatosUsuPue(data);
            } catch (error) {
                console.error(error.message);
            } finally {
                setCargaDatUsuPue(false);
            }
        };
        todosUsuarioPuesto();
    }, [actualiza]);
    //*******
    // filtros
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        usuarioName: { value: null, matchMode: 'contains' },
        clienteSigla: { value: null, matchMode: 'contains' },
        proyectoSigla: { value: null, matchMode: 'contains' },
        proyectoNombre: { value: null, matchMode: 'contains' },
        puestoSigla: { value: null, matchMode: 'contains' },
        puestoNombre: { value: null, matchMode: 'contains' },
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        usuarioName: '',
        clienteSigla: '',
        proyectoSigla: '',
        proyectoNombre: '',
        puestoSigla: '',
        puestoNombre: '',
        global: ''
    });

    const limpiarFiltros = () => {
        setValoresFiltros({
            usuarioName: '',
            clienteSigla: '', 
            proyectoSigla: '',
            proyectoNombre: '',
            puestoSigla: '',
            puestoNombre: '',
            global: ''
        });

        setFiltros({
            global: { value: null, matchMode: 'contains' },
            usuarioName: { value: null, matchMode: 'contains' },
            clienteSigla: { value: null, matchMode: 'contains' },
            proyectoSigla: { value: null, matchMode: 'contains' },
            proyectoNombre: { value: null, matchMode: 'contains' },
            puestoSigla: { value: null, matchMode: 'contains' },
            puestoNombre: { value: null, matchMode: 'contains' }
        });
    };

    // Filtro para texto
        const textoFilterTemplate = (options, field) => {
            return (
                <InputText
                    value={valoresFiltros[field]}
                    onChange={(e) => {
                        const nuevoValor = e.target.value;
                        // Actualizamos el valor visual
                        setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));
    
                        // Actualizamos el filtro real después de un pequeño delay
                        setTimeout(() => {
                            const newFilters = { ...filtros };
                            newFilters[field].value = nuevoValor;
                            setFiltros(newFilters);
                            options.filterApplyCallback(nuevoValor);
                        }, 10);
                    }}
                    placeholder={`Filtro ${field}`}
                    className="w-full"
                />
            );
        };

    //*******

    const handleClick = async () => {
        if (!(usuarios && proyecto && multiPuesto)) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe elegir Usuario, Proyecto y Puesto', life: 3000 });
            return;
        }
        //lista de usuarios
        const lstUsuPost = usuarios.map((item) => item.usuarioId);
        //lista de puestos
        const lstPuesPost = multiPuesto.map((item) => item.sigla);
        const objParam = {
            listaUsuarioId: lstUsuPost,
            listaPuestoSigla: lstPuesPost
        };
        setProcesaReg(true);
        try {
            const response = await registraAcceso(objParam);
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Cambios efectuados', life: 3000 });
            setActualiza((prev) => !prev);
        } catch (error) {
            console.error('Error al registrar');
        } finally {
            setProcesaReg(false);
            setUsuarios([]);
            setProyecto(null);
            setMultiPuesto(null);
        }
    };

    const handleElimina = async () => {
        if (datosUPSelect) {
            setProcesaBorra(true);
            const lstIdElimina = datosUPSelect.map((item) => item.usuarioPuestoId);
            const response = await borraListaUsuPuesto(lstIdElimina);
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Cambios efectuados', life: 3000 });
            setProcesaBorra(false);
            setActualiza((prev) => !prev);
        } else {
            toast.current.show({ severity: 'warning', summary: 'Warning', detail: 'Debe seleccionar algo', life: 3000 });
        }
    };

    return {
        toast,
        cargaUsu,
        usuarios,
        setUsuarios,
        cargaProyecto,
        proyecto,
        setProyecto,
        cargaPuesto,
        multiPuesto,
        setMultiPuesto,
        handleClick,
        procesaReg,
        datosUsuPue,
        datosUPSelect,
        setDatosUPSelect,
        cargaDatUsuPue,
        lstUsuarios,
        lstProyecto,
        lstPuesto,
        handleElimina,
        procesaBorra, 
        filtros, textoFilterTemplate
    };
};

export default useUtilAdmin;
